import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { isScreenBelow640 } from 'store/common/settings/breakpoint/selectors';
import {
  getNotificationType,
  getNotificationDefaultOpenState,
} from 'store/common/notify/selectors';
import { NOTIFY_TYPE_SUBSCRIBE } from 'store/common/notify/constants';

import SimpleNotifier from './views/SimpleNotifier';
import SubscribeNotifier from './views/SubscribeNotifier';

const NotifyTypeSwitcher = ({ notificationType, isOpenByDefault, isMobile }) => {
  switch (notificationType) {
    case NOTIFY_TYPE_SUBSCRIBE:
      return <SubscribeNotifier isOpen={isOpenByDefault} {...{ isMobile }} />;
    default:
      return <SimpleNotifier isOpen={isOpenByDefault} {...{ isMobile }} />;
  }
};

NotifyTypeSwitcher.propTypes = {
  notificationType: PropTypes.string,
  isOpenByDefault: PropTypes.bool,
  isMobile: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  notificationType: getNotificationType(state),
  isOpenByDefault: getNotificationDefaultOpenState(state),
  isMobile: isScreenBelow640(state),
});

// const mapDispatchToProps = {
//   getTypes: getDeviceTypes,
//   selectOption: selectDeviceOption,
// };

export default connect(mapStateToProps)(NotifyTypeSwitcher);
